import { ComponentType } from 'react';
import { SimulationSceneInteraction } from '../../../../types/v2';
import { DisplayInputPlaceholderScene } from '../DisplayInputPlaceholderScene';
import { HardwareWorkbenchPlaceholderScene } from '../HardwareWorkbenchPlaceholderScene';
import { MsiBiosNavigationScene } from '../MsiBiosNavigationScene';
import { WindowsEvidenceScene } from '../WindowsEvidenceScene';


export interface SimulationSceneRendererProps {
  renderState: Record<string, any>;
  interactions?: SimulationSceneInteraction[];
  disabled?: boolean;
  onAction: (actionId: string) => void;
}


const SIMULATION_RENDERERS: Record<string, ComponentType<SimulationSceneRendererProps>> = {
  display_input_placeholder_v1: DisplayInputPlaceholderScene,
  hardware_workbench_placeholder_v1: HardwareWorkbenchPlaceholderScene,
  msi_bios_navigation_v1: MsiBiosNavigationScene,
  windows_evidence_v1: WindowsEvidenceScene,
};


export const getSimulationSceneRenderer = (
  rendererId: string,
): ComponentType<SimulationSceneRendererProps> | null => (
  SIMULATION_RENDERERS[String(rendererId || '').trim()] || null
);
